import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {Loader} from "../../../../components/admin/Loader";
import {EquipmentForm} from "../../../../components/admin/equipment/EquipmentForm";
import {equipmentResultType} from "../../../../types/Api/EquipmentResultType";
import {equipment} from "../../../../models/equipment";
import {equipmentHydrator} from "../../../../models/hydrator/equipmentHydrator";
import {BoxTitle} from "../../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [equipment, setEquipment] = useState(undefined as undefined | equipment);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/equipment/${uuid}`) as Promise<equipmentResultType>;

      setLoading(true);

      result
        .then((r) => {
          setEquipment(equipmentHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (equipment || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier un équipement' : 'Ajouter un équipement'}/>
          <EquipmentForm equipment={equipment} />
        </>
      )}
    </>
  );
}
